type RemoveNullish<T extends readonly unknown[]> = T extends [infer F, ...infer R]
  ? F extends null | undefined
    ? RemoveNullish<R>
    : [F, ...RemoveNullish<R>]
  : []

export const queryKey = <TBase extends string, TParams extends readonly unknown[]>(
  base: TBase,
  ...params: TParams
) => {
  const cleaned = params.filter((p): p is Exclude<typeof p, null | undefined> => p != null)
  return [base, ...cleaned] as [TBase, ...RemoveNullish<TParams>]
}
